import { Images } from "../assets";

const DescriptionBox = ({ title, content, list = [] }) => {
  return (
    <div className="flex flex-col items-start text-start w-full md:w-1/2 lg:w-1/3 bg-turquoise text-black rounded-lg p-6 justify-center gap-5">
      <h3 className="font-title tracking-widest uppercase text-2xl">{title}</h3>

      {content.map((paragraph, index) => (
        <p key={index}>{paragraph}</p>
      ))}

      {list.length > 0 && (
        <ul className="space-y-5">
          {list.map((item, index) => (
            <li key={index} className="flex gap-3 items-start">
              <img
                src={Images.ORANGE_TICK}
                alt="Icône vu orange"
                className="w-6 h-6"
              />
              {item}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default DescriptionBox;
